export const IneligiblePerson = {
    SPOUSE: "Spouse",
    CHILD: "Child",
    CHILD_SPOUSE: "Spouse_Child",
    INSURED: "Insured"
}
export const IneligibleOptions = {
    SPOUSE: "Spouse",
    INSURED: "Myself"
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/Helpers/Constant.js